<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data">
        <div class="data-title flex-space-between" slot="header">
          <p>Claim Removal Requests</p>
          <div class="float-right">
            <Filters />
            <el-tooltip content="Release selected claims" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="releaseSelected()"
                class="ml10"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="Confirm all claims" placement="top" v-if="confirm">
              <el-button
                type="danger"
                circle
                icon="el-icon-check"
                @click.prevent="confirmAll()"
                class="ml10"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="Report" placement="top" v-if="report">
              <el-button
                  type="success"
                  circle
                  icon="el-icon-document"
                  @click="generateReport()"
                  class="ml10"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <el-tabs type="border-card"  @tab-click="tabClick" v-model="tabs">
          <el-tab-pane label="Active" name="active" :status="'Active'">
            <ClaimsRemovalRequests :status = "'active'"/>
          </el-tab-pane>
          <el-tab-pane label="Potential" name="potential" :status="'Potential'">
            <ClaimsRemovalRequests :status = "'potential'"/>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '../components/youtube/claims/FiltersClaims'
import ClaimsRemovalRequests from '../components/youtube/claims/ClaimsRemovalRequests'
import {mapState, mapActions, mapMutations} from 'vuex'

export default {
  components: {
    ClaimsRemovalRequests,
    Filters
  },

  data() {
    return {
      tabs: 'active',
      report: false,
      confirm: false,
      selectedStatus: 'Active'
    }
  },

  computed: {
    ...mapState('youtubeClaims', ['loading', 'claimsRemovalRequest'])
  },

  methods: {
    ...mapActions('youtubeClaims', ['releaseAllClaims','releaseSelectedClaims', 'confirmAllClaims', 'readRequestedClaims', 'readLabels', 'generateReport']),
    ...mapMutations('youtubeClaims', [
      'setPage',
      'setPageSize',
      'setSelectedRows',
      'setSelectAll',
      'setStatus'
    ]),
    releaseAll() {
      this.releaseAllClaims()
    },
    releaseSelected() {
      this.$confirm('You will release selected claim. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
      .then(() => {
        this.releaseSelectedClaims()
        this.setSelectedRows([]);
        this.setSelectAll(false);
          })
      .catch(() => {
        this.$message({
          type: 'info',
          message: 'Release selected claims cancelled'
        })
      })
    },
    confirmAll() {
      this.confirmAllClaims()
    },
    tabClick(tab){
      this.setPageSize(10)
      this.setPage(1)
      this.setSelectedRows([]);
      this.setSelectAll(false);
      this.selectedStatus = tab.$attrs.status
      this.setStatus( tab.$attrs.status)
      this.readRequestedClaims({ claim_type: 'Public', status: this.selectedStatus })
    }
  }
}
</script>
